import { TECH_CHART_SECURITY_KEYS, TECHNICAL_KEYS } from 'ChartApp/ts/features/tech-chart/constants';
import { TechChartSecurity, Technical } from 'ChartApp/ts/interfaces/tech-chart.interface';

import equal from 'Angular/utils/equal/deep-equal';
import { formFlattenedObject } from 'Angular/utils/urls';

class TechnicalCustomSerializer {
    static color = (_color: string): string => encodeURIComponent(_color);

    static params = (_params: (string | number | number[])[]): string => {
        const flattenedParams = _params.map((param) => {
            if (Array.isArray(param)) {
                return `(${param.map((p) => p.toString(10)).join(',')})`;
            }
            return param;
        });
        return flattenedParams.join(',');
    };
}
function serializeTechnical(technical: Technical): string {
    if (!equal(Object.keys(technical).sort(), TECHNICAL_KEYS)) {
        return '';
    }

    const flattenedTechnical = formFlattenedObject(
        technical,
        ['type', 'params', 'include', 'color'],
        TechnicalCustomSerializer
    );

    let serializedTechnical = '';
    Object.entries(flattenedTechnical).forEach(([key, value]) => {
        serializedTechnical = serializedTechnical.concat(`${key}::${value},,`);
    });

    // Remove trailing delim
    serializedTechnical = serializedTechnical.slice(0, serializedTechnical.lastIndexOf(',,'));
    return serializedTechnical;
}

class SecurityCustomSerializer {
    static color = (_color: string): string => encodeURIComponent(_color);

    static id = (_id: string): string => encodeURIComponent(_id);
}

function serializeSecurity(security: TechChartSecurity): string {
    if (!equal(Object.keys(security).sort(), TECH_CHART_SECURITY_KEYS)) {
        return '';
    }

    const flattenedSecurity = formFlattenedObject(security, ['id', 'color'], SecurityCustomSerializer);

    let serializedSecurity = '';
    TECH_CHART_SECURITY_KEYS.forEach((key) => {
        serializedSecurity = serializedSecurity.concat(`${key}:::${flattenedSecurity[key]},,,`);
    });

    // Remove trailing delim
    serializedSecurity = serializedSecurity.slice(0, serializedSecurity.lastIndexOf(',,,'));
    return serializedSecurity;
}

export class TechChartUrlSerializer {
    static chartAnnotations = (_chartAnnotations: string[]): string => {
        if (!_chartAnnotations) return '';
        return _chartAnnotations.join(',');
    };

    static security = (_security: TechChartSecurity): string => {
        if (!_security) return '';
        return serializeSecurity(_security);
    };

    static technicals = (_technicals: Technical[]): string => {
        if (!Array.isArray(_technicals)) return '';

        const technicalParamStrs = _technicals.map(serializeTechnical).filter((s) => s !== '');
        return technicalParamStrs.join(',,,');
    };
}
